import { updateOrgModelsPermissionsRequest } from 'api/Orgs/api';
import { OrgModel } from 'api/Orgs/types';
import getErrorFromPromiseReason from 'app/helpers/getErrorFromPromiseReason';
import { FormValues } from 'components/Dashboard/Orgs/Wizard/OrgModels/OrgModelsSettings/OrgModelsSettings';

import { message, notification } from 'antd';
import { useState } from 'react';

const useUpdateOrgModelsPermissions = (onUpdated: (orgModels: OrgModel[]) => void) => {
  const [ isUpdating, setIsUpdating ] = useState<boolean>(false);

  const updateOrgModelsPermissions = (orgId: string, formValues: FormValues) => {
    setIsUpdating(true);

    updateOrgModelsPermissionsRequest(orgId, formValues)
      .then(({ data }) => {
        onUpdated(data);
        message.success('Model was updated');
      })
      .catch((reason) => {
        notification.error({ duration: 0, type: 'error', message: getErrorFromPromiseReason(reason) });
      })
      .finally(() => {
        setIsUpdating(false);
      });
  };

  return { isUpdating, updateOrgModelsPermissions };
};

export default useUpdateOrgModelsPermissions;
